/**
 @ngdoc service
 @name mapItemTileService
 @description
 factory used by mapTilesJsonData.js to construct tile data into tileData object
 */

(function() {
    'use strict';

    var mapItemTileService = function(tileDataFactory) {

        var map = function(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData){
            var self = this;

            // Assigning tile factory function with parameters to variable
            var tileFactory = new tileDataFactory.constructTileData(rawTileData, commonLabels, objectTilesLabels, lookupValues, requesterData);

            // Adding labels to column structured data
            if(rawTileData.adminEdit){
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('universalId', 'adminEdit'));
            }else{
                tileFactory.addFieldToColumn1(tileFactory.field.newLinkField('universalId', 'editURI'));
            }
            tileFactory.addFieldToColumn1(tileFactory.field.newField('title'));
            tileFactory.addFieldToColumn1(tileFactory.field.newField('orderingManager'));

            tileFactory.addFieldToColumn2(tileFactory.field.newAddressField('workingAddress'));
            tileFactory.addFieldToColumn2(tileFactory.field.newOrganisationField('procurerOrgUnitName', 'procurerOrgName'));

            tileFactory.addFieldToColumn3(tileFactory.field.newField('dateOrdered', 'dateTime'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('startDate', 'dateTime'));
            tileFactory.addFieldToColumn3(tileFactory.field.newField('mspCoordinator'));
            if(rawTileData.totalApplications > 0){
                var totalApplications;
                if(rawTileData.applicationsAwaitingReview && rawTileData.totalApplications){
                    totalApplications = rawTileData.applicationsAwaitingReview + " / " + rawTileData.totalApplications;
                }
                if(rawTileData.totalApplicationsURI){
                    tileFactory.addFieldToColumn3({label:objectTilesLabels.jobApplicants.label, value:totalApplications, link: rawTileData.totalApplicationsURI});
                }else{
                    tileFactory.addFieldToColumn3({label:objectTilesLabels.jobApplicants.label, value:totalApplications});
                }
            }

            tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('candidateAttributesRequired'));
            tileFactory.addFieldToColumn4(tileFactory.field.newField('jobSource'));

          if(rawTileData.totalPostings > 0){
                tileFactory.addFieldToColumn4(tileFactory.field.newField('totalPostings'));
                tileFactory.addFieldToColumn4(tileFactory.field.newFieldBooleanYesOrNo('closingSoon'));
            }
            tileFactory.addFieldToColumn4(tileFactory.field.newField('adminCoordinator'));

            tileFactory.addTextField(tileFactory.textField.newTextField('description'));

            // Adding status to tile data

            // status
            // 210: "Draft"
            // 211: "Open"
            // 212: "Paused"
            // 213: "Closed"
            // secondaryStatus
            // 214: "Placed"
            // 215: "Awaiting Auth"
            // 216: "Processed"
            // 217: "Rejected"
            // 398: "Distributed"
            // 399: "Part-Filled"
            // 400: "Filled"
            // 611: "Completed"
            // 774: "Cancelled"
            tileFactory.addStatus(tileFactory.status.newCombinedStatus('status', 'secondaryStatus',
                // Positives
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_COMPLETED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_FILLED
                    ]
                ],

                // Negatives
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_REJECTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_CLOSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_CANCELLED
                    ]
                ],
                // Warnings
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_PART_FILLED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ],
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_PAUSED,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DISTRIBUTED
                    ]
                ],
                [
                    [
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS_OPEN,
                        tileFactory.LOOKUP_VALUE.ITEM_STATUS2_DRAFT
                    ]
                ]
            ));

            tileFactory.addStatus(tileFactory.status.newTrueBooleanOrHide('retrospectiveItem'));

            if(rawTileData.isPrincipal && rawTileData.itemFrameworkNameHoverText) {
                tileFactory.addStatus(tileFactory.status.newFrameworkStatus('itemFrameworkNameHoverText'));
            }

            return tileFactory.tileData;

        };

        return {
            map : map
        };
    };

    mapItemTileService.$inject = ['tileDataFactory'];
    angular.module('app').factory('mapItemTileService', mapItemTileService);
}());
